(function () {
    'use strict';
    var controllerId = 'cndPSedeImport';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'partecipazioneId', 'aziende', 'aziendaId', 'tRuoloCode', 'isSuper', fn_cndPSedeImport]);

    function fn_cndPSedeImport($scope, datacontext, $uibModalInstance, partecipazioneId, aziende, aziendaId, tRuoloCode, isSuper) {
        $scope.record = {};
        $scope.record.Id = 0;
        $scope.aziende = aziende;
        $scope.tRuoloCode = tRuoloCode;
        $scope.isSuper = isSuper;
        $scope.title = 'Importa sede';

        $scope.sedeId = '';

        $scope.aziendaSedi = [];

        $scope.selectedEntities = 0;
        $scope.click_entity = click_entity;

        $scope.bMultiple = true;
        $scope.checkAll = function () {
            if ($scope.selectedAll) {
                $scope.selectedAll = true;
            } else {
                $scope.selectedAll = false;
            }

            click_entity();
        };
        
        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.CNDPartecipazioneId = partecipazioneId;
        }

        if (aziendaId) {
            $scope.aziendaId = aziendaId;
            $scope.record.APLId = aziendaId;
            getSedi();
        }

        $scope.change_APL = change_APL;
        $scope.change_Sede = change_Sede;

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            $scope.opened2 = false;
            if (iOpened == 1) 
                $scope.opened1 = true;
            if (iOpened == 2) 
                $scope.opened2 = true;
                
        };

        $scope.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                $scope.record.DDG_Dt = '';
                $scope.changed = true;
            }
            if (iOpened == 2) {
                $scope.record.Autor_Dt = '';
                $scope.changed = true;
            }
        };

        $scope.format = "dd/MM/yyyy";

        $scope.ok = function (isValid) {
            if (isValid) {
                console.info('$scope.record', $scope.record);
                if ($scope.bMultiple) {
                    var list = [];
                    $("input:checkbox[name=listId]:checked").each(function () {
                        var sede = {};

                        sede.CNDPartecipazioneId = $scope.record.CNDPartecipazioneId;
                        sede.APLId = $scope.record.APLId;

                        var id = $(this).val();
                        var entity = _.find($scope.aziendaSedi, function (item) {
                            return item.Id == id;
                        });

                        sede.AziendaSedeId = entity.Id;

                        sede.ComuneId = entity.ComuneId;
                        sede.ProvinciaId = entity.ProvinciaId;
                        sede.TIndirizzoId = sede.TIndirizzoId;
                        sede.Indirizzo = entity.Indirizzo;
                        sede.Civico = entity.Civico;
                        sede.Cap = entity.Cap;
                        sede.Accred = entity.Accred;
                        sede.InCorso = entity.InCorso;
                        sede.DDG_Num = entity.DDG_Num;
                        sede.DDG_Dt = entity.DDG_Dt;
                        sede.Accred_Codice = entity.Accred_Codice;
                        sede.Accred_Sub = entity.Accred_Sub;
                        sede.Autor_Num = entity.Autor_Num;
                        sede.Autor_Dt = entity.Autor_Dt;

                        list.push(sede);
                    });

                    var result = addMultiple(list);
                    $uibModalInstance.close(result);
                }
                else {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.pSede_add(item).then(function (data) {
                return data;
            });
        }

        function addMultiple(items) {
            console.info('addMultiple', items);
            return datacontext.pSede_AddMultiplo(items).then(function (data) {
                return data;
            });
        }

        function change_APL () {
            getSedi();
        }


        function getSedi() {
            $scope.aziendaSedi = [];
            $scope.selectedEntities = 0;
            if ($scope.record.APLId && $scope.record.APLId > 0) {
                var iStato = 11; //Non modificabili e not in CNDPartecipazioniSedi
                return datacontext.aziendaSede_getAll(0, 0, '', $scope.tRuoloCode, $scope.record.APLId, 0, 0, $scope.record.CNDPartecipazioneId, iStato, '').then(function (data) {
                    console.info('aziendaSedi', data);
                    return $scope.aziendaSedi = data;
                });
            }
        }

        function change_Sede(sedeId) {
            initializeRecord();
            if (sedeId && sedeId > 0) {
                var sede = _.find($scope.aziendaSedi, function (o) { o.Id == sedeId; });
                if (sede) {
                    $scope.record.ComuneId = sede.ComuneId;
                    $scope.record.ProvinciaId = sede.ProvinciaId;
                    $scope.record.TIndirizzoId = sede.TIndirizzoId;
                    $scope.record.Indirizzo = sede.Indirizzo;
                    $scope.record.Civico = sede.Civico;
                    $scope.record.Cap = sede.Cap;
                    $scope.record.DDG_Num = sede.DDG_Num;
                    $scope.record.DDG_Dt = sede.DDG_Dt;
                }
            }
        }

        function initializeRecord() {
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDPartecipazioneId = partecipazioneId;
            $scope.record.APLId = aziendaId;
        }

        function click_entity() {
            $scope.selectedEntities = $("input:checkbox[name=listId]:checked").length;
        }

    }
})();